import http from '../../../../api/http'

function retrieveAllCorporationListPaging(paramObj) {
    return http.post('/admin/corporation/retrieveAllCorporationListPaging', paramObj);
}

function retrieveAllCorporationListExcel(paramObj) {
    return http.post('/admin/corporation/retrieveAllCorporationListExcel', {
        paramObj
    }, {
        responseType: 'blob',
    });
}

function retrieveCorporation(corpId) {
    return http.get(`/mypage/ojf/corporation/retrieveCorporation?corpId=${corpId}`);
}

function updateCorporation(paramObj) {
    return http.post('/mypage/ojf/corporation/updateCorporation', paramObj);
}

function retrieveCorpEmpListPaging(paramObj) {
    return http.post('/admin/jobFair/retrieveCorpEmpListPaging', paramObj);
}

function retrieveAllRecruitmentHallByCorpIdPaging(paramObj) {
    return http.post('/admin/ojf/recruitmentHall/retrieveAllRecruitmentHallByCorpIdPaging', paramObj);
}

function retrieveRecruitmentHall(ojfId, corpId) {
    return http.get(`/mypage/ojf/recruitmentHall/retrieveRecruitmentHall?ojfId=${ojfId}&corpId=${corpId}`);
}

function updateRecruitmentHall(paramObj) {
    return http.post('/mypage/ojf/recruitmentHall/updateRecruitmentHall', paramObj);
}

function updateJoinStateBySeq(paramObj) {
    return http.post('/admin/ojf/recruitmentHall/updateJoinStateBySeq', paramObj);
}

function retrieveAdminJobNoticeListByCorpIdPaging(paramObj) {
    return http.post('/admin/ojf/jobNotice/retrieveAdminJobNoticeListByCorpIdPaging', paramObj);
}

function retrieveCorpApplicantListPaging(paramObj) {
    return http.post('/admin/ojf/applicant/retrieveCorpApplicantListPaging', paramObj);
}

function retrieveCorpInterestHallEntryPaging(paramObj) {
    return http.post('/admin/ojf/interestHallEntry/retrieveCorpInterestHallEntryPaging', paramObj);
}

function retrieveAllInterviewProposalEntryListByCorpIdPaging(paramObj) {
    return http.post('/admin/ojf/interviewProposalEntry/retrieveAllInterviewProposalEntryListByCorpIdPaging', paramObj);
}

export default {
    retrieveAllCorporationListPaging,
    retrieveAllCorporationListExcel,
    retrieveCorporation,
    updateCorporation,
    retrieveCorpEmpListPaging,
    retrieveAllRecruitmentHallByCorpIdPaging,
    retrieveRecruitmentHall,
    updateRecruitmentHall,
    updateJoinStateBySeq,
    retrieveAdminJobNoticeListByCorpIdPaging,
    retrieveCorpApplicantListPaging,
    retrieveCorpInterestHallEntryPaging,
    retrieveAllInterviewProposalEntryListByCorpIdPaging
}
